const stringUtils = {
  isEmptyString(value: string): boolean {
    return value ? value.trim().length === 0 : true;
  },
  isTrue(value: string): boolean {
    return value === 'true';
  },
  isFalse(value: string): boolean {
    return value === 'false';
  },
  capitalize(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  },
  pluralize(string: string, count: number): string {
    if (string.length === 0) return '';
    return count === 1 ? string : `${string}s`;
  },
  truncateString(string: string, numberOfCharactersToShow: number): string {
    if (string.length === 0) return '';
    return `${string.substring(0, numberOfCharactersToShow)}...`;
  },
};

export default stringUtils;
